<template>
<div>
    <SimpleForm api="fieldMapper" title="Field Mapper" id="field-mapper" :fields="fields" @loaded="onLoaded" ref="fieldMapperForm"/>
    <otif-table :columns="field_mapping_columns" :paginated="true" :rows="fm_rows" title="Field Type Mappings" @change="updateFieldMappings"/>
</div>
</template>

<script>

import SimpleForm from '../../../components/forms/SimpleForm.vue';

const formFields = [
    ['enabled', {component: 'otif-switch'}],
    'name'
];

export default {
    data() {
        return {
            fields: formFields,
            field_mapping_columns: [{
                name: 'source',
                label: 'Source'
            },{
                name: 'target',
                label: 'Target'
            }],
            fm_rows: []
        }
    },

    methods: {
        onLoaded(data) {
            this.fm_rows = data.fieldMappings.value.map((v) => [v.source, v.target]);
            console.log(this.fm_rows);
        },

        updateFieldMappings($e) {
            this.$refs['fieldMapperForm'].setValue('fieldMappings', $e.rows.map((row) => {
                return {
                    source: row[0],
                    target: row[1]
                }
            }));
        }
    },

    components: {
        SimpleForm
    }
}

</script>
